// docs/60 DC14: the crawl card's state the board and the HUD share — whether the journal is open,
// and the lore fragment just read (the card flashes it open as the pulse plays).
import { create } from 'zustand';
import { deviceNow } from '../time';

interface CrawlStore {
  journalOpen: boolean;
  /** The lore fragment the playback just read (index into `crawl.lore`) and when, to flash it. */
  flash?: { lore: number; at: number };
  /** docs/140 DT13: the briefing card is up (opened at a crawl's start, reopened from the crawl card). */
  briefOpen: boolean;
  /** The encounter whose briefing has opened on its own already (once per encounter and browser tab). */
  briefedFor?: string;
  setBrief(open: boolean, encounter?: string): void;
  setJournal(open: boolean): void;
  flashLore(lore: number): void;
}

export const useCrawl = create<CrawlStore>()((set) => ({
  journalOpen: false,
  briefOpen: false,
  setBrief(open, encounter) { set(encounter !== undefined ? { briefOpen: open, briefedFor: encounter } : { briefOpen: open }); },
  setJournal(open) { set({ journalOpen: open }); },
  flashLore(lore) { set({ journalOpen: true, flash: { lore, at: deviceNow() } }); },
}));
